import React from 'react';

const RowCollectionModuleMemo = ({ nodeId }) => {
  return (
    <></>
  );
};

export const RowCollectionModule = React.memo(RowCollectionModuleMemo);
